import Faq from '@/views/app/faq/faq.view'
import ThemeOne from '@/views/app/faq/general-theme-one.view'
import ThemeTwo from '@/views/app/faq/general-theme-two.view'
import ThemeThree from '@/views/app/faq/general-theme-three.view'
import ThemeFour from '@/views/app/faq/general-theme-four.view'

export default [{
  path: 'faq',
  name: 'faq',
  alias: 'index',
  component: Faq,
  meta: {
    breadcrumb: 'Preguntas frecuentes',
    title: 'FAQ',
    colorHeader: '#E64858',
    top: 0,
    position: 'fixed',
    height: 30
  },
  children: [
    {
      path: 'general-theme-one',
      name: 'generalOne',
      alias: 'index',
      component: ThemeOne,
      meta: {
        breadcrumb: 'Tema general',
        title: 'Tema general',
        colorHeader: '#E64858',
        top: 0,
        position: 'fixed',
        height: 30
      }
    },
    {
      path: 'general-theme-two',
      name: 'generalTwo',
      component: ThemeTwo,
      meta: {
        breadcrumb: 'Tema general',
        title: 'Tema general',
        colorHeader: '#E64858',
        top: 0,
        position: 'fixed',
        height: 30
      }
    },
    {
      path: 'general-theme-three',
      name: 'generalThree',
      component: ThemeThree,
      meta: {
        breadcrumb: 'Tema general',
        title: 'Tema general',
        colorHeader: '#E64858',
        top: 0,
        position: 'fixed',
        height: 30
      }
    },
    {
      path: 'general-theme-four',
      name: 'generalFour',
      component: ThemeFour,
      meta: {
        breadcrumb: 'Tema general',
        title: 'Tema general',
        colorHeader: '#E64858',
        top: 0,
        position: 'fixed',
        height: 30
      }
    }
  ]
}]



// WEBPACK FOOTER //
// ./src/router/routes/app/faq/faq.router.js